import Scene from "./scene";

class SceneClass extends Scene {
    constructor({ image, cameraPos, viewer, cameraStart, name = "", setActual = () => {

    }, goBack = null, details = [{ name: "", desc: "" }] }) {

        super({image: image, cameraPos: cameraPos, viewer: viewer, cameraStart: cameraStart, name: name, setActual: setActual })

        this.goBack = goBack;
        this.details = details;
    }

    createMenu() {
        return (
            <>
                {
                    this.goBack !== null ?
                        
                            <div className='fixed z-50 bg-gray-800 px-5 py-2  flex flex-row gap-2 left-1/2 bottom-10 rounded-md text-white font-bold -translate-x-1/2 ' onClick={() => {
                                this.goBack.loadScene()
                            }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="white" class="bi bi-door-open" viewBox="0 0 16 16">
                                    <path d="M8.5 10c-.276 0-.5-.448-.5-1s.224-1 .5-1 .5.448.5 1-.224 1-.5 1" />
                                    <path d="M10.828.122A.5.5 0 0 1 11 .5V1h.5A1.5 1.5 0 0 1 13 2.5V15h1.5a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1H3V1.5a.5.5 0 0 1 .43-.495l7-1a.5.5 0 0 1 .398.117M11.5 2H11v13h1V2.5a.5.5 0 0 0-.5-.5M4 1.934V15h6V1.077z" />
                                </svg>
                                <div>
                                    Wyjdź
                                </div>
                            </div>
                        :
                        <></>
            }

                <div className='fixed z-50 p-2 flex flex-col gap-2 left-0 max-w-60'>
                    <div className="flex flex-row gap-2 items-center">
                        <div className="bg-gray-800 p-1 rounded-md w-fit">

                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="white" class="bi bi-info-square-fill" viewBox="0 0 16 16">
                                <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.93 4.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                            </svg>
                        </div>
                        <div className='rounded-md text-lg font-bold bg-gray-800  px-5 text-white flex items-center py-[10px] leading-3'>
                            Informacje
                        </div>
                    </div>
                    <div className="flex flex-col gap-2">


                        {this.details.map((e) => {
                            return (

                                <div className="flex flex-col rounded-md font-bold bg-gray-800  px-2 text-white items-start py-[4px]">
                                    <div className="text-xs ">
                                        {e.name}
                                    </div>
                                    <div className="text-md">
                                        {e.desc}
                                    </div>
                                </div>
                            )
                        })}

                    </div>
                </div>
            </>
        )

    }
}

export default SceneClass